import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TypeCesEnum } from 'src/app/domain/registration/enums/type-ces.enum';
import { ToastService } from 'src/app/shared/services/toast/toast.service';

@Component({
  selector: 'app-input-file-with-comment-comment',
  templateUrl: './input-file-with-comment-comment.component.html',
  styleUrls: ['./input-file-with-comment-comment.component.sass']
})
export class InputFileWithCommentCommentComponent implements OnInit {
  element: any;

  constructor(
    public dialogRef: MatDialogRef<InputFileWithCommentCommentComponent>,
    @Inject(MAT_DIALOG_DATA)
    data: { type: TypeCesEnum; element: string },
    private toastService: ToastService
  ) {
    this.element = data.element;
  }

  ngOnInit(): void {
  }

  public clickNo() {
    this.dialogRef.close();
  }

  public clickOk() {
    if (this.element)
      this.dialogRef.close({
        element: this.element.toUpperCase(),
      });
    else this.toastService.showWarn('Digite um comentário.');
  }

}
